import React from "react";
import { MediumPrimaryButton} from "@worthy-npm/clarity";
import styled from "styled-components";
import CircaApi from "../../../lib/api/circaApi";
import StyledSelect from "./styledSelect";
import PropTypes from "prop-types";

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 40px;
`;

const Input = styled.input`
    height: 54px;
    padding: 16px 24px;
    border-radius: 16px;
    border: 1px solid #D2D5D7;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 400;
    background-color: #F2F0EE;
    ::placeholder{
        color: #D2D5D7;
    }
`;

const COUNTRIES = [
    { name: 'United States', code: 'us'},
    // { name: 'Hong Kong', code: 'hk'},
    // { name: 'Spain', code: 'es'}
];

class ZipCode extends React.Component {
    constructor(props) {
        super(props);

        this.setOffices = props.setOffices;
        this.state = { country: this.getDefaultCountry().value, zipcode: null };
    }

    getCountries() {
        return COUNTRIES.map((c) => {
            return { label: c.name, value: c.code};
        });
    }

    getDefaultCountry(){
        return this.getCountries()[0];
    }

    isSubmitEnable(){
        return  Boolean(this.state.country) && Boolean(this.state.zipcode);
    }

    setZipcode(value){
        this.setState({zipcode: value.target.value});
    }


    setCountry(value) {
        this.setState({country: value[0].value });
    }

    async retrieveOffices(){
        const offices = await CircaApi.getOffices(this.state.zipcode, this.state.country);
        this.setOffices(offices);
    }

    render() {
        return (
            <div className="offices-drop-off-wrapper">
                <Container>
                    <div  className="countries">
                        <StyledSelect
                            searchable={false}
                            options={this.getCountries()}
                            values={[this.getDefaultCountry()]}
                            onChange={(value) => this.setCountry(value)}
                        />
                    </div>

                    <Input className="zip-code" placeholder="Zip code" onChange={this.setZipcode.bind(this)} type="number" step="1" autoFocus={true}/>
                </Container>

                <div className="zip-code-next-btn" >
                    <MediumPrimaryButton
                        text="Next"
                        click={async (stopAnimation) => {
                            stopAnimation()
                            await this.retrieveOffices()
                        }}
                        disabled={!this.isSubmitEnable()}
                        overrideCSS={{
                            marginTop: '0',
                            height: '47px',
                            borderRadius: '16px',
                            textTransform: 'none',
                            fontSize: '16px',
                            fontWeight: '500'
                    }}
                    overrideWrapperCSS={{}}
                />
            </div>
        </div>
    )
}
}

ZipCode.propTypes = {
setOffices: PropTypes.func.isRequired
};

export default ZipCode;
